import React, { Component, useState } from 'react';
import { Modal, Button, TreeSelect, message, Form, Input } from 'antd';
import { addProviderApi } from '../api';
import { formateTree } from '../../../util/tool';
import './providerModal.less';

const layout = { labelCol: { span: 8, }, wrapperCol: { span: 14, }, };
const tailLayout = { wrapperCol: { offset: 1, span: 22, }, };
const { localStorage } = window;

const AddProviderModalComponent = (props) => {
  const { tree } = props;
  const [form] = Form.useForm();
  const [selectTreeData, setTreeData] = useState(undefined);
  const onTreeChange = value => {
    setTreeData(value);
  };

  const onFinish = async (values) => {
    const { data: { code, msg } } = await addProviderApi(values);
    if (+code === 0) {
      message.success(msg, .5, props.handleOk());
    } else {
      message.error(msg);
    }
  };

  const onCancel = () => {
    props.handleCancel();
  };
  return (
    <Form {...layout} form={form} name="control-hooks" onFinish={onFinish}>
      <Form.Item name="rel_company_id" label="供应商名称：" rules={[{ required: true }]}>
        <TreeSelect
          showSearch
          treeNodeFilterProp='title'
          style={{ width: '100%' }}
          value={selectTreeData}
          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
          treeData={tree}
          placeholder="请选择供应商名称"
          treeDefaultExpandAll
          onSelect={onTreeChange}
        />
      </Form.Item>
      <Form.Item name="rel_company_name" label="ERP供应商名称：" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="primary_code" label="ERP供应商编码：" rules={[{ required: true }]}><Input /></Form.Item>
      <Form.Item name="sub_code" label="ERP供应商二级细分："><Input /></Form.Item>

      <Form.Item {...tailLayout}>
        <div className='erp-form-add-btn-container'>
          <Button className='erp-form-add-btn' htmlType="button" onClick={onCancel}>取消</Button>
          <Button className='erp-form-add-btn' type="primary" htmlType="submit">保存并添加</Button>
        </div>
      </Form.Item>
    </Form>
  );
};

// const formateTree = (data = [],companyId) => {
//   return data.map(item => {
//     const { company_name, company_id, children } = item;
//     const tree = formateTree(children);
//     return { title: company_name, value: company_id, key: company_id, children: tree, self: '11', disabled: +company_id === +companyId };
//   });
// };
export default class AddProviderModal extends Component {
  constructor(props) {
    super(props);
    this.state = { tree: [] };
  }

  async componentDidMount() {
    // const { data: { code, data = [] } } = await companyTree();
    //2025-12-16 该功能需要改造
    const code = 0;
    const data = [{
      "company_id": '',
      "company_name": "该功能已禁用",
      "company_pid": '',
      "key": '',
      "title": "该功能已禁用",
      "value": '',
      "children": []
    }];
    const companyId = localStorage.getItem('companyId');
    if (+code === 0) {
      const tree = formateTree(data, companyId);
      this.setState({ tree });
    }
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  handleOk = () => {
    this.props.searchFn();
    this.props.hideModal(false);
  };

  handleCancel = () => {
    this.props.hideModal(false);
  };

  render() {
    const { tree } = this.state;
    return (
      <>
        <Modal
          className='add-provider-modal'
          open={true}
          title="新增供应商"
          closable={false}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={null}
        >
          <AddProviderModalComponent tree={tree} handleOk={this.handleOk} handleCancel={this.handleCancel} />
        </Modal>
      </>
    );
  }
}
